/* GulfData — tier-upgrade upsell modal
 * Intercepts the PDP "Add to Cart" click (main + sticky buttons), offers a
 * margin-safe data upgrade for the selected plan, then hands control back to
 * the theme's own add-to-cart logic (radio swap + re-click), so all existing
 * UI states (Added ✓, bottom bar, sticky express form) keep working.
 *
 * Fails open by design: any error, missing data, or slow asset load means the
 * original add-to-cart proceeds untouched. Wallet express buttons (Apple Pay /
 * Google Pay / PayPal) are not intercepted.
 */
(function () {
  'use strict';

  var modal = document.querySelector('[data-gd-upsell]');
  var form = document.getElementById('gpForm');
  if (!modal || !form) return;

  /* ---------- data ---------- */

  var VDATA = null;
  try {
    var dataEl = document.querySelector('[data-gd-upsell-variants]');
    VDATA = JSON.parse(dataEl.textContent);
    if (!VDATA || !VDATA.variants) return;
  } catch (e) { return; }

  var MAP = null; // { sourceVariantId: [targetVariantId, ...] }
  try {
    fetch(modal.getAttribute('data-offers-url'))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j && j.v === 1 && j.map) MAP = j.map; })
      .catch(function () {});
  } catch (e) {}

  /* ---------- helpers ---------- */

  function parsePlan(title) {
    var gb = null, days = null;
    var mGb = /(\d+(?:\.\d+)?)\s*GB/i.exec(title);
    var mMb = /(\d+)\s*MB/i.exec(title);
    var mD = /(\d+)\s*Day/i.exec(title);
    if (mGb) gb = parseFloat(mGb[1]);
    else if (mMb) gb = parseInt(mMb[1], 10) / 1000;
    if (mD) days = parseInt(mD[1], 10);
    if (/unlimited/i.test(title)) return null;
    return (gb && days) ? { gb: gb, days: days } : null;
  }

  function dataLabel(gb) {
    return gb < 1 ? Math.round(gb * 1000) + ' MB' : gb + ' GB';
  }

  // Re-render an amount in the same currency format as a reference money string
  // (same approach as the PDP's own fmtMoney — no hardcoded symbols).
  function splitMoney(str) {
    str = String(str || '');
    var m = str.match(/[\d.,]+/);
    if (!m) return { prefix: str, suffix: '', num: '0' };
    var idx = str.indexOf(m[0]);
    return { prefix: str.slice(0, idx), suffix: str.slice(idx + m[0].length), num: m[0] };
  }
  function fmtMoney(refStr, amount) {
    var p = splitMoney(refStr);
    var decSep = '.', thouSep = ',';
    if (p.num.lastIndexOf(',') > p.num.lastIndexOf('.')) { decSep = ','; thouSep = '.'; }
    var parts = amount.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return p.prefix + parts[0] + decSep + parts[1] + p.suffix;
  }

  function variantInfo(id) {
    var v = VDATA.variants[String(id)];
    if (!v) return null;
    var plan = parsePlan(v.t);
    if (!plan) return null;
    return { id: String(id), title: v.t, cents: v.c, f: v.f, gb: plan.gb, days: plan.days };
  }

  function getSelectedVariantId() {
    var checked = form.querySelector('input[name="id"]:checked');
    return checked ? checked.value : null;
  }

  function getQty() {
    var q = form.querySelector('input[name="quantity"]');
    var n = parseInt(q ? q.value : '1', 10);
    return Math.max(1, Math.min(10, isNaN(n) ? 1 : n));
  }

  function track(action, fromId, toId) {
    try {
      var detail = { action: action, from: fromId, to: toId || null };
      document.dispatchEvent(new CustomEvent('gd:upsell', { detail: detail }));
      (window.dataLayer = window.dataLayer || []).push({
        event: 'gd_upsell_' + action, gd_upsell_from: fromId, gd_upsell_to: toId || null
      });
    } catch (e) {}
  }

  /* ---------- intercept ---------- */

  var bypass = false;
  var ctx = null; // { srcId, btn, prevFocus, prevOverflow }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gp-add-main],[data-gp-add-bottom]');
    if (!btn || bypass || !MAP) return;

    var srcId = getSelectedVariantId();
    if (!srcId) return;

    var dismissed = false;
    try { dismissed = !!sessionStorage.getItem('gdup_seen_' + srcId); } catch (err) {}
    if (dismissed) return;

    var targets = MAP[srcId];
    if (!targets || !targets.length) return;

    var src = variantInfo(srcId);
    if (!src) return;

    var offers = [];
    for (var i = 0; i < targets.length && offers.length < 2; i++) {
      var t = variantInfo(targets[i]);
      if (t && t.cents > src.cents && t.gb > src.gb) offers.push(t);
    }
    if (!offers.length) return;

    // Take over this click; theme's own handler never runs.
    e.preventDefault();
    e.stopImmediatePropagation();
    e.stopPropagation();
    openModal(src, offers, btn);
  }, true);

  /* ---------- modal ---------- */

  var offersHost = modal.querySelector('[data-gd-upsell-offers]');
  var subEl = modal.querySelector('[data-gd-upsell-sub]');
  var keepBtn = modal.querySelector('[data-gd-upsell-keep]');

  function offerCard(src, offer, isValue) {
    var per = offer.cents / 100 / offer.gb;
    var srcPer = src.cents / 100 / src.gb;
    var savePct = Math.round((1 - per / srcPer) * 100);
    var saveLine = savePct >= 1
      ? '<span class="gd-upsellCardDelta">Save ' + savePct + '% per GB</span>'
      : '';
    var cls = 'gd-upsellCard' + (isValue ? ' gd-upsellCard--value' : '');
    var badge = isValue ? '<span class="gd-upsellBadge">★ Best value</span>' : '';
    return (
      '<button type="button" class="' + cls + '" data-gd-upsell-accept="' + offer.id + '">' +
        badge +
        '<span class="gd-upsellCardPlan">' + dataLabel(offer.gb) + ' · For ' + offer.days + ' days</span>' +
        '<span class="gd-upsellCardPrice">' + offer.f + '</span>' +
        '<span class="gd-upsellCardMeta">' + fmtMoney(src.f, per) + '/GB instead of ' + fmtMoney(src.f, srcPer) + '/GB</span>' +
        saveLine +
        '<span class="gd-upsellCardCta">Upgrade to ' + dataLabel(offer.gb) + '</span>' +
      '</button>'
    );
  }

  function openModal(src, offers, btn) {
    var html = '';
    // "value" card first if it exists (second entry in map = lowest per-GB)
    if (offers.length === 2) {
      html += offerCard(src, offers[1], true) + offerCard(src, offers[0], false);
    } else {
      html += offerCard(src, offers[0], true);
    }
    offersHost.innerHTML = html;
    if (subEl) {
      subEl.textContent = 'You picked ' + dataLabel(src.gb) + ' · For ' + src.days +
        ' days. Bigger plans cost less per GB — upgrade in one tap.';
    }
    if (keepBtn) keepBtn.textContent = 'No thanks, keep ' + dataLabel(src.gb);

    ctx = {
      srcId: src.id,
      btn: btn,
      prevFocus: document.activeElement,
      prevOverflow: document.body.style.overflow
    };

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = modal.querySelector('.gd-upsellCard');
    if (first) first.focus();
    track('shown', src.id);
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (ctx) {
      document.body.style.overflow = ctx.prevOverflow || '';
      if (ctx.prevFocus && ctx.prevFocus.focus) { try { ctx.prevFocus.focus(); } catch (e) {} }
    }
  }

  function redispatch(btn) {
    bypass = true;
    try { btn.click(); } finally { bypass = false; }
  }

  function directAdd(targetId, btn) {
    // Fallback if the target variant has no radio on the page.
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(targetId), quantity: getQty() })
    }).then(function (res) {
      if (!res.ok) throw new Error('add failed');
      return res.json();
    }).then(function () {
      if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.textContent = original; }, 1200); }
    }).catch(function () {
      if (btn) { btn.textContent = 'Try again'; setTimeout(function () { btn.textContent = original; }, 1200); }
    }).then(function () { if (btn) btn.disabled = false; });
  }

  function accept(targetId) {
    if (!ctx) return;
    var c = ctx; ctx = null;
    closeModalWith(c);
    var radio = form.querySelector('input[name="id"][value="' + targetId + '"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      redispatch(c.btn);
    } else {
      directAdd(targetId, c.btn);
    }
    try { sessionStorage.setItem('gdup_seen_' + c.srcId, '1'); } catch (e) {}
    track('accept', c.srcId, targetId);
  }

  function keep() {
    if (!ctx) return;
    var c = ctx; ctx = null;
    closeModalWith(c);
    try { sessionStorage.setItem('gdup_seen_' + c.srcId, '1'); } catch (e) {}
    redispatch(c.btn); // never block the purchase — original add proceeds
    track('decline', c.srcId);
  }

  function closeModalWith(c) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = c.prevOverflow || '';
    if (c.prevFocus && c.prevFocus.focus) { try { c.prevFocus.focus(); } catch (e) {} }
  }

  modal.addEventListener('click', function (e) {
    var acceptBtn = e.target.closest('[data-gd-upsell-accept]');
    if (acceptBtn) { accept(acceptBtn.getAttribute('data-gd-upsell-accept')); return; }
    if (e.target.closest('[data-gd-upsell-close],[data-gd-upsell-keep]')) keep();
  });

  document.addEventListener('keydown', function (e) {
    if (!modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); keep(); return; }
    if (e.key === 'Tab') {
      var focusables = modal.querySelectorAll('button');
      if (!focusables.length) return;
      var firstEl = focusables[0], lastEl = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    }
  });
})();
